/*
 * Public API Surface of ng2-daterangepicker
 */

export * from './lib/ng2-daterangepicker.service';
export * from './lib/ng2-daterangepicker.component';
export * from './lib/ng2-daterangepicker.module';
